// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Vcf1","empty":"ModalGraph_empty__1vO6p"};